import { getEntityTypeForPayload } from "us.collection.case/components/MessageTemplates/Function";
import { DocumentType, DrawerType } from "us.collection.case/constants/MessageTemplates";
import { IMessageTemplatePinStatus } from "us.collection.case/interfaces";
import { EntityType } from "us.collection/constants";
import { ActivityVersion } from "us.common/constants";

/**
 * @description create pinStatusData object for update pin status by using patch request
 * @param {pinUnpinStatus}IMessageTemplatePinStatus
 * @returns return the pinStatusData object
 */
export const createMessageTemplatePatchObject = (
  pinUnpinStatus: IMessageTemplatePinStatus
) => {
  try {
    const { isPin, templateId, entityType } = pinUnpinStatus;

    const pinStatusObject = [
      {
        op: "add",
        path: "/isPin",
        value: !isPin,
      },
    ];

    return { pinStatusObject, templateId, entityType };
  } catch (error) {
    return {};
  }
};

/**
 * @description Send message template as attachment in mail api request
 * @param this
 * @returns
 */
export function SendEmail(this: any) {
  return {
    queueId: this.queueId,
    entityId: this.entityType ==
    EntityType.AR ? this.arId : this.caseId,
    entityType: getEntityTypeForPayload(this.entityType),
    messages: this.content,
    messageType: this.messageType,
    fileName: this.fileName,
    settings: {...this.settings, Emailreciever: this.to, Emailsubject: this.subject},
    documentDetails: this.documentDetails,
    sendMessagesAsAttachment: true,
    emailOrSMS: this.to,
    messageContent: this.body == "" ? `<p></p>` : this.body,
    activityVersion: ActivityVersion.V2,
  };
}

/**
 * @description Send email api request
 * @param this
 * @returns
 */
export function ExecuteTemplate(this: any) {
  return {
    queueId: this.queueId,
    entityId: this.entityType ==
    EntityType.AR ? this.arId : this.caseId,
    entityType: getEntityTypeForPayload(this.entityType),
    messages: this.editContent,
    messageType: this.messageType,
    fileName: this.fileName,
    settings: this.settings,
    documentDetails: this.documentDetails,
    sendMessagesAsAttachment: false,
    emailOrSMS: "",
    messageContent: "",
    activityVersion: ActivityVersion.V2,
  };
}

/**
 * @description Get template content for v2 request params
 * @param this
 * @returns
 */
export function GetTemplateV2Request(this: any) {
  return {
    templateId: this.templateId,
    entityID: this.entityType ==
    EntityType.AR ? this.arId : this.caseId,
    entityType: getEntityTypeForPayload(this.entityType),
    templateName: this.templateName,
    templateCategory: this.templateCategory,
    outputFormat:
         this.plugin?.toLowerCase() === DocumentType.EMAIL
          ? DocumentType.EMAIL
          : this.plugin.toLowerCase(),
    action: this.isPreview ? DrawerType.PREVIEW : DrawerType.EDIT,
    activityVersion: ActivityVersion.V2
  };
}

/**
 * @description Get basic data request params
 * @param this
 * @returns
 */
export function GetBasicDataRequest(this: any) {
  return {
    entityId: this.entityType ==
					EntityType.AR ? this.arId : this.caseId,
		entityType: getEntityTypeForPayload(this.entityType),
  };
}
